import { dataHooks } from '../../../../../libs/dataHooks';

export const colorsFilterItemDataHooks = dataHooks<{
  item: { active: boolean };
}>('color-filters-item');
